import { IDSK } from "@examspark/types";

import { getResource } from "./resource";

export const getTasksForResource = async (resource: IDSK) => {
  return getResource({
    label: "GetResourceTasks",
    fields: `
    id
    sk
    name
    tasks {
      id
      sk
      resource {
        id
        sk
        idInc
        name
        createdAt
        updatedAt
        maturity
        priority
        dueAt
        workspaceId
        assignee {
          firstName
          lastName
          avatarHash
          id
        }
      }
    }
  `,
    variables: {
      id: resource.id,
      sk: resource.sk,
    },
  });
};
